import { Redirect, useLocation } from 'react-router-dom'

import { resolveLegacyPortalPath } from './legacyPortalPaths'
import { PageNotFound } from './PageNotFound'

export function LegacyPortalRedirect() {
  const location = useLocation()
  const pathname = resolveLegacyPortalPath(location.pathname)

  if (!pathname) {
    return <PageNotFound />
  }

  return <Redirect to={{ pathname, search: location.search }} />
}
